import React from "react";
import "./Preloader.sass"
const Preloader = () => {
    return(
        <div className='main-bg'>
            <div className='preloader'>
                <div className="preloader__window">
                    <div className="preloader__line line1">

                    </div>
                    <div className="preloader__line line2">

                    </div>
                    <div className="preloader__line line3">

                    </div>
                    <div className="preloader__line line4">

                    </div>
                </div>
            </div>
        </div>
    )
};

export default Preloader